import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import styleHelper from '@utils/styleHelper';
import { Fonts, Spacings, breakpoints } from '@styles/index';

const H2 = styled.h2`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.H2};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin: ${Spacings.SPACING_0B};
  @media only screen and (max-width: ${breakpoints.tablet}) {
    font-size: 24px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    font-size: 22px;
  }
  ${({ lineClamp }) =>
    lineClamp ? styleHelper.lineClampStyle(lineClamp) : null}
`;

export default H2;

H2.propTypes = {
  color: PropTypes.string,
  lineClamp: PropTypes.number
};

H2.defaultProps = {
  color: 'var(--color-text-primary)',
  lineClamp: null
};
